import {Enum} from 'enumify'

class PackageTypeParser extends Enum {}
PackageTypeParser.initEnum({
  BUDGET: {
    apiName: 'BUDGET',
    capitalizedText: 'Budget',
    lowercase: 'budget'
  },
  BASIC: {
    apiName: 'BASIC',
    capitalizedText: 'Budget', // Budget is the new name for Basic
    lowercase: 'budget'
  },
  PREMIUM: {
    apiName: 'PREMIUM',
    capitalizedText: 'Premium',
    lowercase: 'premium'
  },
  CUSTOM: {
    apiName: 'CUSTOM',
    capitalizedText: 'Custom',
    lowercase: 'custom'
  }
})
export function getPackageTypeParser (apiName) {
  for (const packageType of PackageTypeParser.enumValues) {
    if (packageType.apiName === apiName) {
      return packageType
    }
  }
}
export default PackageTypeParser



// WEBPACK FOOTER //
// ./src/components/shared/enums/package-type-parser.js